module.exports = __webpack_public_path__ + "img/offline-number-tip-v2.ac13d64e.png";